/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import cx from 'classnames';
import { TERMS_OF_SERVICE_URL } from 'site-kit/src/constants/kbArticles';

export function TermsAndPrivacyPolicy({
    className,
    ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cx('text-sm color-text-02 text-center', className)} {...rest}>
            By logging in, I accept {process.env.SITE_NAME}
            &#39;s&nbsp;
            <a className="font-weight-semibold" href={TERMS_OF_SERVICE_URL}>
                Terms of Service
            </a>{' '}
            and{' '}
            <a
                className="font-weight-semibold"
                href={`${process.env.SITE_ROOT}/privacy-policy`}
            >
                Privacy Policy
            </a>
            .
        </div>
    );
}
